@if (pendingUserPsychologists().length > 0) {
  <div class="approve-container">
    <div class="title">{{ 'approve_user_connection.title' | translate }}</div>
    @for (request of pendingUserPsychologists(); track request.id) {
      <div class="pending-row">
        <div class="info">
          <span class="name">{{request.users?.first_name + ' ' + request.users?.last_name}}</span>
        </div>
        <div class="actions">
          @if (loading()) {
            <span class="loader"></span>
          } @else {
            <mat-icon matRipple class="reject" (click)="reject(request)">thumb_down</mat-icon>
            <mat-icon matRipple class="accept" (click)="approve(request)">thumb_up</mat-icon>
          }
        </div>      
      </div>
    }
  </div>
}
